// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"798af4f1","461":"3a4d209c","638":"5d4ebe41","726":"0facacfb","730":"4792dd5f"}[chunkId] + ".chunk.js";
};